<div class="d-flex h-100">
  <div class="m-auto text-center">
    <ng-lottie class="d-flex align-self-center" [options]="options"></ng-lottie>
    <h1 class="fs-1 lh-1">Sessione scaduta</h1>
    <h2 class="fs-3 lh-1">Scansiona nuovamente il QR!</h2>
  </div>
</div>